export function isDevEnv() {
  return typeof window !== 'undefined' && window.location.hostname !== 'ai.ourbox.co.kr';
}
